import type { Dispatch, AnyAction } from 'redux';

import * as FindAllCompanyAPI from 'ab-api/web/credentials/findCompanyCredentials';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

export function findCompanyCredentials() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<FindAllCompanyAPI.W_Credentials_FindAllForCompany_VM>(FindAllCompanyAPI.URL());
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
